var _rect, _mask, _path, _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 58,
    rx: 17,
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_470_3188",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5253 43.8841C42.2385 43.8841 52.5445 36.8113 52.5445 28.0866C52.5445 19.3618 42.2385 12.2891 29.5253 12.2891C16.8122 12.2891 6.5061 19.3618 6.5061 28.0866C6.5061 33.0097 9.78754 37.4068 14.9313 40.304L15.2124 47.7109L23.4987 43.3372C25.4196 43.6938 27.4401 43.8841 29.5253 43.8841Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9313 40.304L16.9298 40.2281L16.8874 39.1103L15.9128 38.5614L14.9313 40.304ZM15.2124 47.7109L13.2139 47.7867L13.3345 50.9636L16.146 49.4796L15.2124 47.7109ZM23.4987 43.3372L23.8638 41.3708L23.1801 41.2438L22.5652 41.5684L23.4987 43.3372ZM50.5445 28.0866C50.5445 31.5991 48.4716 34.9996 44.6707 37.6081C40.8789 40.2103 35.5303 41.8841 29.5253 41.8841V45.8841C36.2336 45.8841 42.3946 44.0215 46.9341 40.9061C51.4644 37.797 54.5445 33.2988 54.5445 28.0866H50.5445ZM29.5253 14.2891C35.5303 14.2891 40.8789 15.9628 44.6707 18.5651C48.4716 21.1736 50.5445 24.5741 50.5445 28.0866H54.5445C54.5445 22.8744 51.4644 18.3761 46.9341 15.267C42.3946 12.1517 36.2336 10.2891 29.5253 10.2891V14.2891ZM8.5061 28.0866C8.5061 24.5741 10.579 21.1736 14.38 18.5651C18.1718 15.9628 23.5204 14.2891 29.5253 14.2891V10.2891C22.8171 10.2891 16.6561 12.1517 12.1166 15.267C7.58623 18.3761 4.5061 22.8744 4.5061 28.0866H8.5061ZM15.9128 38.5614C11.1535 35.8807 8.5061 32.0447 8.5061 28.0866H4.5061C4.5061 33.9746 8.42159 38.9328 13.9498 42.0466L15.9128 38.5614ZM17.211 47.635L16.9298 40.2281L12.9327 40.3798L13.2139 47.7867L17.211 47.635ZM22.5652 41.5684L14.2788 45.9421L16.146 49.4796L24.4323 45.1059L22.5652 41.5684ZM29.5253 41.8841C27.5614 41.8841 25.6632 41.7048 23.8638 41.3708L23.1336 45.3035C25.1761 45.6828 27.3188 45.8841 29.5253 45.8841V41.8841Z",
    fill: "#BCBBBE",
    mask: "url(#path-2-inside-1_470_3188)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0725,
    cy: 28.1928,
    r: 2.89157,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6386,
    cy: 28.1928,
    r: 2.89157,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.205,
    cy: 28.1928,
    r: 2.89157,
    fill: "#D9D9D9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.2db387a84754cb8ff0212f4fc5e4bb81.svg";
export { ForwardRef as ReactComponent };